import LocationNotAllowed from './LocationNotAllowed';

export default LocationNotAllowed;
